import { Thunk } from '../../../helpers/redux/Thunk';
import { getActiveUser } from '../../user';

export const loadSystemData = (): Thunk => async dispatch => {
    await dispatch(getActiveUser());
};
